import { render } from "./OptionList.vue?vue&type=template&id=085c8589&scoped=true"
import script from "./OptionList.vue?vue&type=script&lang=js"
export * from "./OptionList.vue?vue&type=script&lang=js"

import "./OptionList.vue?vue&type=style&index=0&id=085c8589&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085c8589"]])

export default __exports__